import axios from "axios";
import { AppDispatch } from "../Store";
import { devTicketSlice } from "../reducers/Dev-TicketsSlice";
import {
  CREATE_DEV_TICKET,
  GET_ALL_DEV_TICKETS,
  GET_DEV_TICKET_BY_ID,
  COMPLETE_DEV_TICKET,
  GET_MY_TICKETS,
} from "./endpoints";

export const getAllDevTickets =
  (params?: {
    status?: "InProcess" | "Completed";
    operatorId?: string;
    developerId?: string;
  }) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(devTicketSlice.actions.devTicketsFetching());

      const res = await axios.get(GET_ALL_DEV_TICKETS, {
        params,
        withCredentials: true,
      });

      dispatch(devTicketSlice.actions.devTicketsFetchingSuccess(res.data));
    } catch (error: any) {
      dispatch(devTicketSlice.actions.devTicketsFetchingFailed(error.message));
    }
  };

export const getDevTicketById =
  (id: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(devTicketSlice.actions.devTicketFetching());

      const res = await axios.get(`${GET_DEV_TICKET_BY_ID}/${id}`, {
        withCredentials: true,
      });

      dispatch(devTicketSlice.actions.devTicketFetchingSuccess(res.data));
    } catch (error: any) {
      dispatch(devTicketSlice.actions.devTicketFetchingFailed(error.message));
    }
  };

export const createDevTicket =
  (formData: FormData) => async (dispatch: AppDispatch) => {
    try {
      dispatch(devTicketSlice.actions.addDevTicketLoading());

      const res = await axios.post(CREATE_DEV_TICKET, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      dispatch(devTicketSlice.actions.addDevTicketSuccess(res.data));

      return res.data;
    } catch (error: any) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Ошибка отправки заявки";

      dispatch(devTicketSlice.actions.addDevTicketFailed(message));

      throw new Error(message);
    }
  };

export const completeDevTicket =
  (id: string, data: { developerComment?: string }) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(devTicketSlice.actions.completeDevTicketLoading());

      const res = await axios.patch(
        `${COMPLETE_DEV_TICKET}/${id}/complete`,
        data,
        {
          withCredentials: true,
        },
      );

      dispatch(devTicketSlice.actions.completeDevTicketSuccess(res.data));
    } catch (error: any) {
      dispatch(devTicketSlice.actions.completeDevTicketFailed(error.message));
    }
  };

export const getMyDevTickets =
  (params?: { status?: "InProcess" | "Completed" }) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(devTicketSlice.actions.myDevTicketsFetching());

      const res = await axios.get(GET_MY_TICKETS, {
        params,
        withCredentials: true,
      });

      dispatch(devTicketSlice.actions.myDevTicketsFetchingSuccess(res.data));
    } catch (error: any) {
      dispatch(
        devTicketSlice.actions.myDevTicketsFetchingFailed(
          error.response?.data?.message || error.message,
        ),
      );
    }
  };
